'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _buildOrderedMessageMap = require('./buildOrderedMessageMap');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Message History for a Thread
 *
 * @param {Object} properties
 * @param {Iterable} properties.messages
 * @param {Number} properties.startTimestamp
 * @param {Number} properties.endTimestamp
 * @param {Number} properties.visitorLastReadAtTimestamp
 * @param {Number} properties.numSoftDeletedMessages
 */
var ThreadHistory = function (_Record) {
  _inherits(ThreadHistory, _Record);

  function ThreadHistory() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ThreadHistory);

    return _possibleConstructorReturn(this, (ThreadHistory.__proto__ || Object.getPrototypeOf(ThreadHistory)).call(this, _extends({}, properties, {
      messages: (0, _buildOrderedMessageMap.buildOrderedMessageMap)(properties.messages)
    })));
  }

  return ThreadHistory;
}((0, _immutable.Record)({
  messages: (0, _immutable.OrderedMap)(),
  startTimestamp: null,
  endTimestamp: null,
  visitorLastReadAtTimestamp: 0,
  numSoftDeletedMessages: 0
}, 'ThreadHistory'));

exports.default = ThreadHistory;
module.exports = exports['default'];